var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.646,
    height: 15,
    viewBox: "0 0 14.646 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#151515}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zoom",
    transform: "rotate(-90 7.5 7.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_13",
    d: "M13.31 1.648a5.839 5.839 0 0 0-8.12-.011 5.513 5.513 0 0 0-.208 7.727l-.438.428a.923.923 0 0 0-1.283 0L.266 12.716a.871.871 0 0 0 0 1.253l.428.418a.923.923 0 0 0 1.283 0l2.993-2.924a.871.871 0 0 0 0-1.253l.438-.428a5.839 5.839 0 0 0 8.11-.4 5.513 5.513 0 0 0-.208-7.734zm-8.767 9.4l-2.994 2.921a.308.308 0 0 1-.428 0l-.428-.418a.29.29 0 0 1 0-.417l2.994-2.924a.315.315 0 0 1 .428 0l.428.418a.29.29 0 0 1 0 .417zm8.34-1.879a5.228 5.228 0 0 1-7.27 0 4.938 4.938 0 0 1 0-7.1 5.228 5.228 0 0 1 7.27 0 4.944 4.944 0 0 1-.001 7.097z",
    className: "cls-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16",
    transform: "translate(12.027 2.483)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14",
    d: "M.428 0L0 .418a3.781 3.781 0 0 1 0 5.43l.428.418A4.361 4.361 0 0 0 .428 0z",
    className: "cls-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.34d8960985545cb32aed34b0897474c7.svg";
export { ForwardRef as ReactComponent };